import { render, staticRenderFns } from "./PrimeAudioUploader.vue?vue&type=template&id=b9f6c458&scoped=true"
import script from "./PrimeAudioUploader.vue?vue&type=script&lang=js"
export * from "./PrimeAudioUploader.vue?vue&type=script&lang=js"
import style0 from "./PrimeAudioUploader.vue?vue&type=style&index=0&id=b9f6c458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f6c458",
  null
  
)

export default component.exports